module.exports = __webpack_public_path__ + "static/media/header-back.f65e6da6.jpg";